import window from 'common/window'

interface IUnauthedRoutes {
  [key: string]: boolean
}

const pathPatterns: (() => RegExp)[] = []

const sectionRegex = /:\w+/gi
const createPathPatternIfNecessary = (path: string) => {
  if (path.indexOf(':') !== -1) {
    const pattern = path.replace(sectionRegex, '[^/]+')
    const patternMatcher = () => new RegExp(pattern, 'gi')
    pathPatterns.push(patternMatcher)
  }
}

export const unauthedRoutes: IUnauthedRoutes = {}

export const isRegisteredUnauthedRoute = (path: string) => {
  const matchesExactly = !!unauthedRoutes[path]
  if (matchesExactly) {
    return true
  }
  for (let i = 0; i < pathPatterns.length; i++) {
    const patternMatcher = pathPatterns[i]()
    if (patternMatcher.test(path)) {
      return true
    }
  }
  return false
}

export const registerUnauthedRoute = (path: string) => {
  if (!unauthedRoutes[path]) {
    createPathPatternIfNecessary(path)
    unauthedRoutes[path] = true
  }
  return path
}

export const isCurrentRouteUnauthed = () => {
  return isRegisteredUnauthedRoute(window.location.pathname)
}
